/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetMemberSuggestionsQueryResponse, HierarchiesControllerGetMemberSuggestionsPathParams, HierarchiesControllerGetMemberSuggestionsQueryParams, HierarchiesControllerGetMemberSuggestions401, HierarchiesControllerGetMemberSuggestions403 } from "../../models/hierarchiesController/HierarchiesControllerGetMemberSuggestions";

function getHierarchiesControllerGetMemberSuggestionsUrl(scopeId: HierarchiesControllerGetMemberSuggestionsPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/hierarchies/${scopeId}/member-suggestions` as const }  
  return res
}

/**
 * @description Return distinct users who hold an active role anywhere in this scope subtree (the scope itself plus descendant teams/projects), filtered by a partial email/name match. Backend-filtered for invite autocomplete.
 * @summary Suggest existing members for invite typeahead
 * {@link /api/v1/hierarchies/:scopeId/member-suggestions}
 */
export async function hierarchiesControllerGetMemberSuggestions(scopeId: HierarchiesControllerGetMemberSuggestionsPathParams["scopeId"], params: HierarchiesControllerGetMemberSuggestionsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<HierarchiesControllerGetMemberSuggestionsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetMemberSuggestions401 | HierarchiesControllerGetMemberSuggestions403>, unknown>({ method : "GET", url : getHierarchiesControllerGetMemberSuggestionsUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}